import { PageDataHandler } from "@/lib/utility/data/page-data-handler";
import { IPersonGroup, PersonGroup } from "@/models/person-group.entity";
import { MrfiktivPersonGroupControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import Vue from "vue";
import { Action, Module, getModule } from "vuex-module-decorators";
import { ActionEnum } from "../enum/authActionEnum";
import { ResourceEnum } from "../enum/authResourceEnum";
import { PaginatedBaseStore } from "../paginated-base.store";
import { PersonGroupDataAccessLayer } from "./access-layers/person-group.access-layer";
import { PaginationFilterListElement } from "./base-pagination.store";
import { PersonGroupPageDataProvider } from "./page-data-provider/person-group.page-data-provider.ts";
import { PartnerModule } from "./partner";
import { UserModule } from "./me-user.store";

@Module({
  dynamic: true,
  namespaced: true,
  name: "person-group",
  store
})
export class PersonGroupPaginationStore extends PaginatedBaseStore<
  IPersonGroup,
  MrfiktivPersonGroupControllerGetParamsGen
> {
  protected _data = PersonGroupDataAccessLayer;
  protected _pageProvider = PersonGroupPageDataProvider;
  protected _pager = new PageDataHandler(this._data, this._pageProvider);

  filterOptions: PaginationFilterListElement[] = PersonGroup.filterables;

  @Action
  async reset(): Promise<void> {
    super.reset();
    if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.PERSON_GROUP, PartnerModule.partner.id)) {
      this.setFilters([]);
      await this.fetchFirstPage({ partnerId: PartnerModule.partner.id }).catch(e => Vue.$log.error(e));
    }
  }
}

export const PersonGroupModule = getModule(PersonGroupPaginationStore);
